export const FETCH_PURITY_REQUEST = 'FETCH_PURITY_REQUEST';
export const FETCH_PURITY_SUCCESS = 'FETCH_PURITY_SUCCESS';
export const FETCH_PURITY_FAILURE = 'FETCH_PURITY_FAILURE';

export const ADD_PURITY_REQUEST = 'ADD_PURITY_REQUEST';
export const ADD_PURITY_SUCCESS = 'ADD_PURITY_SUCCESS';
export const ADD_PURITY_FAILURE = 'ADD_PURITY_FAILURE';

export const UPDATE_PURITY_REQUEST = 'UPDATE_PURITY_REQUEST';
export const UPDATE_PURITY_SUCCESS = 'UPDATE_PURITY_SUCCESS';
export const UPDATE_PURITY_FAILURE = 'UPDATE_PURITY_FAILURE';

export const DELETE_PURITY_REQUEST = 'DELETE_PURITY_REQUEST';
export const DELETE_PURITY_SUCCESS = 'DELETE_PURITY_SUCCESS';
export const DELETE_PURITY_FAILURE = 'DELETE_PURITY_FAILURE';

export const PURITY_FORM_ERROR = 'PURITY_FORM_ERROR';
export const PURITY_FORM_SUCCESS = 'PURITY_FORM_SUCCESS';
export const SET_PURITY_EDIT = 'SET_PURITY_EDIT';
export const CLEAR_PURITY_EDIT = 'CLEAR_PURITY_EDIT'; 